import { makeStyles } from "@material-ui/styles";

export const useCurrencyStyles: any = makeStyles(
  (theme: { [key: string]: any }) => ({
    root: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.paper,
    },
    paper: {
      padding: theme.spacing(2),
    },
    tableRow: {
      "&:hover": {
        backgroundColor: "#e3e3e3",
      },
      cursor: "pointer",
    },
    tableCell: {
      fontSize: "15px",
      fontWeight: "bold",
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: "black",
    },
    totalCellStyle: {
      borderBottom: "1px solid gray",
    },
    middleTotalcell: {
      borderBottom: "1px solid gray",
    },
    totalValueCell: {
      borderBottom: "1px solid gray",
    },
    total: {
      textAlign: "left",
      fontWeight: "bold",
      color: "#000",
    },
    value: {
      textAlign: "right",
      fontWeight: "bold",
      color: "#000",
    },
    denominationTitle: {
      fontWeight: "bold",
    },
  })
);
